<template>
  <div :class="['message-hint', value.isTime ? 'message-hint-time' : 'message-hint-normal']">
    {{ value.isTime ? formatTime(value.text) : value.text }}
  </div>
</template>

<script>
export default {
  name: 'MessageHint',
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
    formatTime(time) {
      let date = new Date()
      let timeDate = new Date(time)

      if (date.getDate() == timeDate.getDate() && date.getMonth() == timeDate.getMonth()) {
        let hour = timeDate.getHours()
        if (hour < 5) {
          return `凌晨 ${this.$utils.dateFormat('HH:MM', time)}`
        } else if (hour < 6) {
          return `清晨 ${this.$utils.dateFormat('HH:MM', time)}`
        } else if (hour < 12) {
          return `上午 ${this.$utils.dateFormat('HH:MM', time)}`
        } else if (hour < 13) {
          return `中午 ${this.$utils.dateFormat('HH:MM', time)}`
        } else if (hour < 18) {
          return `下午 ${this.$utils.dateFormat('HH:MM', time)}`
        } else if (hour < 24) {
          return `晚上 ${this.$utils.dateFormat('HH:MM', time)}`
        }
      } else {
        return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'message-hint',
  (
    --hint-color: var(--base-color-text-regular)
  ),
  (
    --hint-color: var(--base-color-white)
  )
);

.message-hint {
  font-size: var(--base-font-size-extra-small);
  color: var(--hint-color);
  height: var(--base-size-48);
  line-height: var(--base-size-48);
  text-align: center;
}
</style>
